import {FormValues} from '@/locations/form/create/types';
import {validateName} from '@/validate';

export default ({locationName}: FormValues) => {
  return {locationName: validateName(locationName)} as any;
};
